import script from "./MobileDispatchList.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileDispatchList.vue?vue&type=script&setup=true&lang=js"

import "./MobileDispatchList.vue?vue&type=style&index=0&id=328fd494&scoped=true&lang=css"
import "./MobileDispatchList.vue?vue&type=style&index=1&id=328fd494&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-328fd494"]])

export default __exports__